import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import Logo from "../Logo";
import AdminMenuItem from "../AdminMenuItem";

const Container = styled.div`
  width: 100%;
  height: auto;
  border-right: solid 1px ${(props) => props.theme.lightGreyColor};
  display: flex;
  padding: 0.5rem;
  flex-direction: column;
  overflow-y: auto;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    width: 100%;
    height: 60vh;
    padding: 1rem 0.8rem;
    padding-bottom: 10vh;
    background-color: white;
  }
`;

const Wrapper = styled.div`
  width: 15vw;
  border-right: solid 1px ${(props) => props.theme.lightGreyColor};
  height: 100vh;
  display: flex;
  padding: 0.5rem;
  z-index: 6;
  padding-bottom: 10vh;
  flex-direction: column;
  background-color: white;
  box-shadow: ${(props) => props.theme.boxShadow};
  position: sticky;
  top: 0;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    width: 100%;
    height: auto;
    max-height: 80vh;
    position: fixed;
    padding: 0px;
    top: auto;
    bottom: 0;
    left: 0;
  }
`;

const DesktopMenuText = styled.p`
  padding: 1rem;
  cursor: pointer;
  border-radius: 0.4rem;
  :hover {
    background-color: ${(props) => props.theme.lightGreyColor};
  }
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    display: none;
  }
`;
const Text = styled.p``;
const MobileHeader = styled.div`
  flex-direction: row;
  width: 100%;
  padding: 1rem;
  padding-bottom: 2rem;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${(props) => props.theme.boxShadow};
  position: sticky;
  cursor: pointer;
  color: ${(props) => props.theme.primaryColor};
  :hover {
    background-color: ${(props) => props.theme.lightGreyColor};
    * {
      opacity: 0.7;
    }
  }

  display: none;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    display: flex;
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    display: none;
  }
`;

const AdminButton = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.blueColor};
  border-radius: 1rem;
  color: white;
  cursor: pointer;
  padding: 1rem;
  :hover {
    opacity: 0.7;
  }
  margin: 1rem 0px;
`;

const UserMenu: React.SFC<any> = ({ theme, isAdmin, history }) => {
  const [showMenu, setShowMenu] = useState(
    window.innerWidth >= parseInt(theme.maxWidth.replace("px", ""))
  );
  const routes = [
    {
      name: "Dashboard",
      path: "/admin",
      exact: true,
    },
    {
      name: "Products",
      path: "/admin/products",
    },
    {
      name: "Packages",
      path: "/admin/packages",
    },
    {
      name: "Agents",
      path: "/admin/agents",
    },
    {
      name: "Cash Wallet",
      path: "/admin/cash_wallet",
      items: [
        {
          name: "All",
          path: "/admin/cash_wallet",
        },
        {
          name: "Smart Partner Bonus 合伙人奖金",
          path: "/admin/cash_wallet/smart_partner",
        },
        {
          name: "MDS 每月扩展奖金",
          path: "/admin/cash_wallet/mds_bonus",
        },
        {
          name: "Break Away 同级直推奖金",
          path: "/admin/cash_wallet/breakaway_bonus",
        },
        {
          name: "Overriding 一次性越级奖金",
          path: "/admin/cash_wallet/overriding",
        },
        {
          name: "Seasonal Development Bonus 季度扩展奖金",
          path: "/admin/cash_wallet/seasonal_bonus",
        },
        {
          name: "Withdrawal 提款",
          path: "/admin/cash_wallet/withdrawal",
        },
        {
          name: "Transaction Fee 手续费",
          path: "/admin/cash_wallet/transaction_fee",
        },
      ],
    },
    {
      name: "Restock Orders",
      path: "/admin/restock_orders",
    },
    {
      name: "Shipment Orders",
      path: "/admin/shipment_orders",
      description: "Request Shipment, MMS, RB, DRB, Retail Orders",
      items: [
        {
          name: "All",
          path: "/admin/shipment_orders",
        },
        {
          name: "Request Shipment",
          path: "/admin/shipment_orders/request_shipment",
        },
        {
          name: "MMS Orders",
          path: "/admin/shipment_orders/mms",
        },
        {
          name: "RB",
          path: "/admin/shipment_orders/rb",
        },
        {
          name: "DRB",
          path: "/admin/shipment_orders/drb",
        },
        {
          name: "Retail Orders",
          path: "/admin/shipment_orders/retail",
        },
      ],
    },
    {
      name: "Sharing",
      path: "/admin",
      items: [
        {
          name: "Gallery",
          path: "/admin/gallery",
        },
        // {
        //   name: "Brand Articles",
        //   path: "/admin/brand_articles",
        // },
      ],
    },
    {
      name: "Settings",
      path: "/admin/settings",
      items: [
        {
          name: "Business Settings",
          path: "/admin/settings",
        },
        // {
        //   name: "Theme & Styles",
        //   path: "/admin/theme_styles",
        // },
        {
          name: "Countries & Shipping",
          path: "/admin/countries_and_shipping",
        },
        // {
        //   name: "Announcement",
        //   path: "/admin/announcement",
        // },
      ],
    },
  ];

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <Wrapper>
      {!showMenu && (
        <DesktopMenuText onClick={toggleMenu}>Show Menu</DesktopMenuText>
      )}
      <MobileHeader onClick={toggleMenu}>
        <Logo height="28px" width="auto" />
        <Text>{showMenu ? "Hide Menu" : "Show Menu"}</Text>
      </MobileHeader>
      {showMenu && (
        <Container>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <AdminButton
            onClick={() => {
              history.push("/");
            }}
          >
            Agent Portal
          </AdminButton>
          {routes.map((r, index) => (
            <AdminMenuItem
              title={r.name}
              path={r.path}
              items={r.items}
              description={r.description}
              key={index}
              exact={r.exact}
            />
          ))}
        </Container>
      )}
    </Wrapper>
  );
};

export default withTheme(withRouter(UserMenu));
